import type {DAL} from '@wix/document-manager-core'
import type {CompRef} from '@wix/document-services-types'
import {ReportableError} from '@wix/document-manager-utils'
import {NON_EXISTING_COMPONENT_ERROR_TYPE} from './constants'

export const validateComponentExists = (dal: DAL, componentPointer: CompRef) => {
    if (!dal.has(componentPointer)) {
        throw new ReportableError({
            message: 'The given component does not exist',
            errorType: NON_EXISTING_COMPONENT_ERROR_TYPE,
            extras: {
                componentPointer
            }
        })
    }
}
